import { LOCALES } from 'i18n/locales';

export const CMSPageIntl = {
    [LOCALES.ENGLISH]: {
        'cms.contactPageSignedOut.title': 'Contact',
        'cms.contactPage.title': 'Contact',
        'cms.cookiesPage.title': 'Cookies',
        'cms.helpPage.title': 'Help',
        'cms.helpSignedOut.title': 'Help',
        'cms.helpContent.title': 'Help Content',
        'cms.HSG47Page.title': 'HSG47 Page',
        'cms.releaseNotes.title': 'Release Notes',
        'cms.workingOn.title': 'Working On',
        'cms.newsPage.title': 'News',
        'cms.newsContent.title': 'News',
        'cms.noOrganisationsPage.title': 'No Active Organisations',
        'cms.privacyPage.title': 'Privacy'
    },
    [LOCALES.WELSH]: {
        'cms.contactPageSignedOut.title': 'Cysylltu',
        'cms.contactPage.title': 'Cysylltu',
        'cms.cookiesPage.title': 'Cwcis',
        'cms.helpPage.title': 'Tudalen Cymorth',
        'cms.helpSignedOut.title': 'Tudalen Cymorth',
        'cms.helpContent.title': 'Cynnwys Cymorth',
        'cms.HSG47Page.title': 'Tudalen HSG47',
        'cms.releaseNotes.title': '[Release Notes]',
        'cms.workingOn.title': '[Working On]',
        'cms.newsPage.title': 'Newyddion',
        'cms.newsContent.title': 'Newyddion',
        'cms.noOrganisationsPage.title': 'Dim Sefydliadau Gweithredol',
        'cms.privacyPage.title': 'Preifatrwydd'
    }
};
